// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationFollowUpResultSearchBase } from './priorAuthorizationFollowUpResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationFollowUpResultSearchResponse {
    'results': Array<PriorAuthorizationFollowUpResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationFollowUpResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<PriorAuthorizationFollowUpResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationFollowUpResultSearchResponse.attributeTypeMap;
    }
}
